__turbopack_context__.v({
  "active": "index-module-scss-module__uUFVYa__active",
  "artPieceImg": "index-module-scss-module__uUFVYa__artPieceImg",
  "artPiecesSection": "index-module-scss-module__uUFVYa__artPiecesSection",
  "drawingImg": "index-module-scss-module__uUFVYa__drawingImg",
  "drawingSection": "index-module-scss-module__uUFVYa__drawingSection",
  "horizontal": "index-module-scss-module__uUFVYa__horizontal",
  "switch": "index-module-scss-module__uUFVYa__switch",
  "vertical": "index-module-scss-module__uUFVYa__vertical",
});
